import { Modal, Button } from "solid-bootstrap";
import { Component, JSXElement } from "solid-js";

export const ModalWindow : Component<{ visible: boolean, children: JSXElement, title: string|JSXElement; onClose: () => void; }> = (props) =>
<Modal show={props.visible}
    onHide={props.onClose}
    contentClassName="modal-content-1000" 
    dialogClassName="modal-dialog-1000"
    size="xl" animation={false}>
    <Modal.Header>
        <Button variant="secondary" onClick={props.onClose} class="modal-button-close">Close</Button>
        <Modal.Title class="modal-title">{props.title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
        {props.children}
    </Modal.Body>
</Modal>;